import {Injectable} from '@angular/core';
import {Http,URLSearchParams,Response} from '@angular/http';
import {BaseService} from '../shared/service/base.service';
import {AuthService} from '../shared/auth/auth.service';
import { Module } from '../shared/model/module.model';
import {Observable} from 'rxjs';
@Injectable()
export class FeaturedHomeService extends BaseService<Module> {

  constructor(authService: AuthService,
              _http: Http) {
    super('/api/modules', authService, _http);
  }

  getHomeModules(): Observable<Module[]> {
    let params: URLSearchParams = new URLSearchParams();


    params.set('view', 'Featured');
     if(this._authService.getUserData() != null){
    console.log(this._authService.getUserData().breezeSessionString);
    if(this._authService.getUserData().breezeSessionString !== undefined){
      params.set('breezeSessionString',this._authService.getUserData().breezeSessionString);
    }else{
      params.set('breezeSessionString',this._authService.getBreezeSessionString());
    }
     console.log('iBreezeUserID' + this._authService.getUserData().iBreezeUserID);
     if(this._authService.getUserData().iBreezeUserID !== undefined){
      params.set('iBreezeUserID',this._authService.getUserData().iBreezeUserID);
    }else{
      params.set('iBreezeUserID','');
    }
  }

    return this._http.get(this._baseUrl + '/getHomeFeaturedModules', {
      headers: this._authService.getAuthorizationHeaders(),
      search: params
    })
      .map((res: Response) => res.json())
      ;
  }

}



// WEBPACK FOOTER //
// ./src/app/featured-home/featured-home.service.ts